import type { Route } from "next";

export interface Partner {
  id: number;
  image: string;
  link: Route;
}

export interface Archivement {
  logo: string;
  company: string;
  content: string;
  author: string;
  role: string;
}

export const partners: Partner[] = [
  {
    id: 1,
    image: "/assets/sdtc-image/trang-chu/people/doitac1.webp",
    link: "/tin-tuc",
  },
  {
    id: 2,
    image: "/assets/sdtc-image/trang-chu/people/doitac2.webp",
    link: "/tin-tuc",
  },
  {
    id: 3,
    image: "/assets/sdtc-image/trang-chu/people/doitac3.webp",
    link: "/tin-tuc",
  },
];

export const archivements: Archivement[] = [
  {
    logo: "/assets/sdtc-image/trang-chu/Logo/sdtc.webp",
    company: "SDTC",
    content:
      "Chúng tôi đã hợp tác với đội ngũ thiết kế website này trong dự án phát triển nền tảng thương mại điện tử của công ty. Điều làm tôi ấn tượng nhất là cách họ thấu hiểu nhu cầu và biến những yêu cầu phức tạp thành một giải pháp dễ sử dụng nhưng đầy hiệu quả. Từ giao diện mượt mà đến tốc độ xử lý nhanh chóng, website của chúng tôi giờ đây không chỉ thu hút khách hàng mà còn giúp tăng doanh thu đáng kể. Đội ngũ luôn sẵn sàng hỗ trợ và đảm bảo mọi thứ hoạt động ổn định. Tôi chắc chắn sẽ tiếp tục hợp tác trong các dự án tiếp theo!",
    author: "Anh Minh",
    role: "CEO công ty Thương mại Điện tử",
  },
  {
    logo: "/assets/sdtc-image/trang-chu/Logo/drTuanAnh.webp",
    company: "Dr.Tuấn Anh",
    content:
      "chúng tôi cải thiện thứ hạng trên Google, tăng lưu lượng truy cập tự nhiên lên 40% chỉ sau 3 tháng. Trong khi đó, CRM giúp quản lý thông tin khách hàng một cách khoa học, từ lịch hẹn đến phản hồi, giúp đội ngũ tiết kiệm thời gian và tăng sự hài lòng của khách. Giao diện thân thiện và hỗ trợ tận tâm từ SeaDragon khiến chúng tôi rất ấn tượng!",
    author: "Bác sĩ Tuấn Anh",
    role: "Bác Sĩ Chuyên Khoa Viện Thẩm Mỹ Nguyễn Tuấn Anh",
  },
  {
    logo: "/assets/sdtc-image/trang-chu/Logo/sdtc.webp",
    company: "SDTC",
    content:
      "Chúng tôi đã tích hợp cả Project Manager, CRM, và BackLink vào chiến dịch marketing của mình, và kết quả thật đáng kinh ngạc. Project Manager giúp tổ chức các chiến dịch phức tạp một cách dễ dàng, CRM hỗ trợ theo dõi và chăm sóc khách hàng tiềm năng, còn BackLink giúp website của chúng tôi leo top tìm kiếm, tăng 30% lưu lượng truy cập. Đội ngũ SeaDragon luôn hỗ trợ nhanh chóng, giúp chúng tôi tối ưu hóa hiệu quả từng sản phẩm.",
    author: "Chị Lan",
    role: "Giám Đốc Marketing Công ty Truyền Thông",
  },
  {
    logo: "/assets/sdtc-image/trang-chu/Logo/sdtc.webp",
    company: "SDTC",
    content:
      "Là một startup công nghệ, chúng tôi cần các giải pháp quản lý hiệu quả nhưng dễ sử dụng. Project Manager giúp đội ngũ của chúng tôi quản lý nhiều dự án đồng thời mà không bị rối, còn CRM hỗ trợ xây dựng mối quan hệ bền vững với khách hàng. Đặc biệt, BackLink đã giúp website của chúng tôi tăng thứ hạng nhanh chóng, mang lại nhiều cơ hội kinh doanh hơn. SeaDragon thực sự là đối tác đáng tin cậy!",
    author: "Anh Hoàng",
    role: "Trưởng Phòng Vận Hành Startup Công Nghệ",
  },
];

export const inspirationImagesTop = [
  "/assets/sdtc-image/trang-chu/carousel/cr1.webp",
  "/assets/sdtc-image/trang-chu/carousel/cr2.webp",
  "/assets/sdtc-image/trang-chu/carousel/cr3.webp",
  "/assets/sdtc-image/trang-chu/carousel/cr4.webp",
  "/assets/sdtc-image/trang-chu/carousel/cr7.webp",
  "/assets/sdtc-image/trang-chu/carousel/cr9.webp",
  "/assets/sdtc-image/trang-chu/carousel/cr10.webp",
];

export const inspirationImagesBottom = [
  "/assets/sdtc-image/trang-chu/carousel/cr18.webp",
  "/assets/sdtc-image/trang-chu/carousel/cr17.webp",
  "/assets/sdtc-image/trang-chu/carousel/cr16.webp",
  "/assets/sdtc-image/trang-chu/carousel/cr15.webp",
  "/assets/sdtc-image/trang-chu/carousel/cr14.webp",
  "/assets/sdtc-image/trang-chu/carousel/cr13.webp",
  "/assets/sdtc-image/trang-chu/carousel/cr12.webp",
  "/assets/sdtc-image/trang-chu/carousel/cr11.webp",
];
